import { ICustomIconProps } from './types';

const IconChevronDown: React.FC<ICustomIconProps> = ({ size = 16, className }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path d='M6 9L12 15L18 9' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default IconChevronDown;
